import * as React from 'react';
import { connect, Provider } from 'react-redux';
import { withRouter } from 'react-router';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import { withDefaultStyles } from '../../utils/material-ui/hoc';
import Content from './containers/content';
import { store } from './store';

const s = store();
const p = persistStore(s);
class Radario extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Provider store={s}>
          <PersistGate loading={null} persistor={p}>
            <Content />
          </PersistGate>
        </Provider>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(withRouter(connect(
  mapStateToProps,
)(Radario)));



// WEBPACK FOOTER //
// ./src/sub-projects/radario/index.tsx